import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'
import {Grid} from '@material-ui/core'

export default React.memo(_ => <Grid container spacing={0}
                                     direction={"column"}
                                     style={{padding: 0, margin: 0}} justify={"flex-start"} alignContent={"center"} alignItems={"stretch"}>
    <DataView module={Constants.module.PEDAGOGIE} object={Constants.donnee.exercice}/>
</Grid>)


// WEBPACK FOOTER //
// ./app/App/Module/Pedagogie/Page/Exercice/index.js